// ICCID充值系统 - 常量定义

// ==================== 商品/套餐状态 ====================
export const PRODUCT_STATUS = {
  OFFLINE: 0,   // 下架
  ONLINE: 1     // 上架
}

export const PRODUCT_STATUS_MAP = {
  0: '下架',
  1: '上架'
}

export const PRODUCT_STATUS_TAG_TYPE = {
  0: 'info',
  1: 'success'
}

// ==================== 分佣类型 ====================
export const COMMISSION_TYPE = {
  PERCENTAGE: 1,    // 百分比
  FIXED: 2          // 固定金额
}

export const COMMISSION_TYPE_MAP = {
  1: '百分比',
  2: '固定金额'
}

// ==================== 支付状态 ====================
export const PAYMENT_STATUS = {
  ALL: -1,      // 全部（仅查询用）
  PENDING: 0,   // 待支付
  PAID: 1,      // 已支付
  FAILED: 2     // 支付失败
}

export const PAYMENT_STATUS_MAP = {
  '-1': '全部',
  0: '待支付',
  1: '已支付',
  2: '支付失败'
}

export const PAYMENT_STATUS_TAG_TYPE = {
  0: 'warning',
  1: 'success',
  2: 'danger'
}

// ==================== 充值状态 ====================
export const RECHARGE_STATUS = {
  ALL: -1,      // 全部（仅查询用）
  PENDING: 0,   // 待充值
  SUCCESS: 1,   // 充值成功
  FAILED: 2     // 充值失败
}

export const RECHARGE_STATUS_MAP = {
  '-1': '全部',
  0: '待充值',
  1: '充值成功',
  2: '充值失败'
}

export const RECHARGE_STATUS_TAG_TYPE = {
  0: 'warning',
  1: 'success',
  2: 'danger'
}

// ==================== 订单退款状态 ====================
export const ORDER_REFUND_STATUS = {
  ALL: -1,          // 全部（仅查询用）
  NO_REFUND: 0,     // 无退款
  REFUNDING: 1,     // 退款中
  REFUNDED: 2,      // 已退款
  FAILED: 3         // 退款失败
}

export const ORDER_REFUND_STATUS_MAP = {
  '-1': '全部',
  0: '无退款',
  1: '退款中',
  2: '已退款',
  3: '退款失败'
}

export const ORDER_REFUND_STATUS_TAG_TYPE = {
  0: 'info',
  1: 'warning',
  2: 'success',
  3: 'danger'
}

// ==================== 退款申请状态 ====================
export const REFUND_STATUS = {
  PENDING: 0,           // 待审核
  APPROVED: 1,          // 审批通过
  REJECTED: 2,          // 审批拒绝
  REFUNDING: 3,         // 退款中
  SUCCESS: 4,           // 退款成功
  FAILED: 5             // 退款失败
}

export const REFUND_STATUS_MAP = {
  0: '待审核',
  1: '审批通过',
  2: '审批拒绝',
  3: '退款中',
  4: '退款成功',
  5: '退款失败'
}

export const REFUND_STATUS_TAG_TYPE = {
  0: 'warning',         // 待审核 - 橙色
  1: 'success',         // 审批通过 - 绿色
  2: 'danger',          // 审批拒绝 - 红色
  3: 'primary',         // 退款中 - 蓝色
  4: 'success',         // 退款成功 - 绿色
  5: 'danger'           // 退款失败 - 红色
}

// ==================== 审批结果 ====================
export const APPROVE_RESULT = {
  PENDING: 0,   // 未审批
  APPROVED: 1,  // 通过
  REJECTED: 2   // 拒绝
}

export const APPROVE_RESULT_MAP = {
  0: '未审批',
  1: '通过',
  2: '拒绝'
}

export const APPROVE_RESULT_TAG_TYPE = {
  0: 'info',
  1: 'success',
  2: 'danger'
}
